import { BANNERS } from '@constants';

export const isHeaderBannerVisible = (banner = {}, showBanners = {}) => {
  const { description = '', id = '' } = banner;

  return Boolean(description) && showBanners[BANNERS.HEADER] !== String(id);
};
